import { Loader } from '@googlemaps/js-api-loader'
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin'
import InfoWindowMixin from '@/mixins/InfoWindowMixin'
import ApiVersions from '@/constants/ApiVersions'

export default {
  mixins: [ScreenSizeMixin, InfoWindowMixin],

  /**
   * This components properties
   */
  props: {
    apiKey: String,
    contextId: String,
    centreLatitude: String,
    centreLongitude: String,
    language: String,
    mapTypeId: String,
    region: String,
    zoom: String,
  },

  /**
   * This components data attributes
   */
  data() {
    return {
      google: null,
      map: null,
      centre: this.getPosition(this.centreLatitude, this.centreLongitude),
      marker: Object,
      alert: null,
    }
  },

  /**
   * Component methods
   */
  methods: {
    /**
     * Initialize component
     */
    async initializeComponent() {
      const self = this
      window.gm_authFailure = () => {
        self.relayEvent({
          event: 'google-api-key-error',
        })
      }
      const loader = new Loader({
        libraries: ['places', 'drawing'],
        apiKey: this.apiKey,
        language: this.language,
        region: this.region,
        version: ApiVersions.GOOGLE_MAPS,
      })
      this.google = await loader.load()
      this.initializeMap()
      this.initInfoWindow()
    },

    isDashboardMap() {
      return !this.$refs.mapContext
    },

    /**
     * Initialize map
     */
    initializeMap() {
      // map configuration
      const mapConfig = {
        zoom: parseInt(this.zoom, 10) || 2,
        mapTypeId: this.mapTypeId || 'roadmap',
        center: this.centre,
        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            west: -180,
            east: 180,
          },
        },
        tilt: 0,
      }

      // map container
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, mapConfig)

      // enable autocomplete
      if (this.$refs.googleSearch) {
        const autocomplete = new this.google.maps.places.Autocomplete(
          this.$refs.googleSearch.$refs.textField.$vnode.elm.lastElementChild,
        )
        autocomplete.setFields(['geometry'])
        autocomplete.addListener('place_changed', () => {
          const geometry = autocomplete.getPlace().geometry
          this.map.fitBounds(geometry.viewport)
          this.map.setCenter(geometry.location)
          if (!this.isDashboardMap()) {
            this.$refs.mapContext.evaluateContextMenu(null, geometry.location)
          }
        })
      }
    },

    /**
     * Gets the position object
     * @param {String} latitude of the position
     * @param {String} longitude of the position
     */
    getPosition(latitude, longitude) {
      return {
        lat: parseFloat(latitude) || 0,
        lng: parseFloat(longitude) || 0,
      }
    },

    /**
     * Relays event message to the parent
     * @param {object} messageData message data containing the event details, options, values
     */
    relayEvent(messageData) {
      messageData.id = this.contextId
      window.parent.postMessage(messageData, window.location.origin)
    },
  },
}
